export const messages = {
  en: {
    merchantManage: {
      search: {
        title: 'Search Conditions',
        storeId: 'Please enter merchant ID',
        name: 'Please enter name',
        tel: 'Please enter phone number'
      },
      list: {
        title: 'Merchant Companies',
        manage: 'Manage'
      },
      table: {
        storeId: 'ID',
        name: 'Name',
        address: 'Address',
        tel: 'Phone',
        createTime: 'Create Time'
      },
      fetchError: 'Failed to fetch merchant data'
    }
  },
  zh: {
    merchantManage: {
      search: {
        title: '查询条件',
        storeId: '请输入商家编号',
        name: '请输入名称',
        tel: '请输入电话'
      },
      list: {
        title: '商家公司',
        manage: '管理'
      },
      table: {
        storeId: '编号',
        name: '名称',
        address: '地址',
        tel: '电话',
        createTime: '创建时间'
      },
      fetchError: '获取商家数据失败'
    }
  }
}